<app-toolbar [title]="title"></app-toolbar>

<div class="container">
  <mat-card class="mat-elevation-z5">
    <div style="vertical-align: middle">
      <span class="material-icons && back-nav" routerLink="/startup">navigate_before</span>
      <h1>Registrati a IBD Tool</h1>
    </div>
    <mat-card-content fxLayout="column">

      <form class="form" [formGroup]="registrationForm" (ngSubmit)="onSubmit(registrationForm.value)">

        <mat-form-field appearance="outline">
          <mat-label>Inserisci la tua email</mat-label>
          <input class="email-input" matInput placeholder="username@domain.com" formControlName="email" (focusin)="notFocused=false" (focusout)="notFocused=true">
          <ng-container *ngIf="registrationForm.get('email').hasError('email') && notFocused">
            <div style="padding-top:15px">
            <span class="error">
             Inserisci un email valida
            </span>
            </div>
          </ng-container>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il tuo nome</mat-label>
          <input matInput placeholder="Nome" formControlName="name" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il tuo cognome</mat-label>
          <input matInput placeholder="Cognome" formControlName="surname" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il tuo codice fiscale</mat-label>
          <input matInput placeholder="Codice fiscale" formControlName="ssn" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci la tua data di nascita</mat-label>
          <input matInput placeholder="Data di nascita" [matDatepicker]="picker" (dateChange)="setDate($event)">
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

        <!--<mat-form-field appearance="outline">
          <mat-label>Inserisci il tuo Comune di nascita</mat-label>
          <input matInput placeholder="Città" formControlName="birthPlace" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci la Provincia del tuo Comune di nascita</mat-label>
          <input matInput placeholder="Provincia" formControlName="province" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il CAP del tuo Comune di nascita</mat-label>
          <input matInput placeholder="CAP" formControlName="cap" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>-->

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il tuo numero di telefono</mat-label>
          <input matInput placeholder="Numero di telefono" formControlName="phoneNumber" (focusin)="notFocused=false" (focusout)="notFocused=true">
        </mat-form-field>

        <mat-form-field appearance="outline" style="padding-bottom: 10px">
          <mat-label>Inserisci una password</mat-label>
          <input matInput type="password" formControlName="password">
        </mat-form-field>

        <mat-form-field appearance="outline">
          <mat-label>Inserisci il tuo ruolo</mat-label>
          <mat-select required>
            <mat-option *ngFor="let value of doctorRoles" [value]="value"
                        (onSelectionChange)="selectResult($event, value)">
              {{value}}
            </mat-option>
          </mat-select>
        </mat-form-field>


        <ng-container *ngIf="submitted">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </ng-container>

        <ng-container *ngIf="!show">
          <button mat-raised-button type="submit" color="primary"
                  [disabled]="!registrationForm.valid">Registrati</button>
        </ng-container>

      </form>

    </mat-card-content>
  </mat-card>
</div>
